import React, { useState, useRef, useEffect } from 'react';
import { Camera } from 'react-camera-pro';
import Webcam from 'react-webcam';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { detectMob } from '../../../utils/common';
import LightBulb from '../../../assets/images/light-bulb.svg';
import Loading from '../../Common/Loading';

import { actionTsoFr } from '../../../store/application/actions';
import { actionApplicationIP, actionErrorCount } from '../../../store/common/actions';

const COUNT_TIMES = 4;

function ConfirmSelfieTakePhoto({ countTimeDefault, flow = 2 }) {
  const camera = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();
  const [countTimes, setCountTimes] = useState(countTimeDefault > 0 ? (5 - countTimeDefault) : COUNT_TIMES);
  useEffect(() => {
    if (location.state?.count || location.state?.count === 0) {
      setCountTimes(location.state?.count);
    }
  }, [location.state?.count]);

  const onSubmit = async () => {
    const utm_params = await getUtmParams();
    const response = await dispatch(
      actionTsoFr({
        photo: image,
        flow: flow,
        utm_params,
      }),
    );

    let url = flow === 2 && response?.sts_code === 0 ? 'confirm-esign-check' : 'confirm-selfie-check-result'
    if (response?.sts_code !== 0) {
      await dispatch(actionErrorCount());
    }
    navigate(`${location.pathname}/${url}`, { replace: true, state: { status: true, flow: flow, response, count: countTimes, path: location.pathname } });
  };

  const getUtmParams = async () => {
    const responseIP = await dispatch(actionApplicationIP());
    let data = {};
    const utm_medium = sessionStorage.getItem('utm_medium');
    const utm_source = sessionStorage.getItem('utm_source');
    const utm_campaign = sessionStorage.getItem('utm_campaign');
    const utm_id = sessionStorage.getItem('utm_id');
    const utm_term = sessionStorage.getItem('utm_term');
    const utm_content = sessionStorage.getItem('utm_content');
    const session_id = localStorage.getItem('session_id');
    data = {
      session_id,
      utm_medium,
      utm_source,
      utm_campaign,
      utm_id,
      utm_term,
      utm_content,
      ip: responseIP?.ip ?? '',
      access_query: `utm_medium=${utm_medium ?? ''}&utm_source=${utm_source ?? ''}&utm_campaign=${utm_campaign ?? ''}&utm_id=${utm_id ?? ''}&utm_term=${utm_term ?? ''}&utm_content=${utm_content ?? ''}`,
    }
    return data;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Loading isVisible={isSubmitting} />
      <div className="fixed w-full z-30 top-0 left-1/2 h-full bg-white" style={{ maxWidth: 414, transform: 'translateX(-50%)' }}>
        <p className="p-4 text-gray text-center">{!image ? '請閣下拍攝自拍照' : '請確認閣下所拍攝的照片'}</p>
        <div className="relative">
          {!image ? (
            <>
              {detectMob() ? (
                <Camera
                  ref={camera}
                  facingMode="user"
                  aspectRatio={4 / 3}
                  errorMessages={{
                    noCameraAccessible: '没有可访问的相机设备。请连接您的相机或尝试其他浏览器。',
                    permissionDenied: '没有权限。请刷新并授予相机权限。',
                    switchCamera: '无法将摄像头切换到其他摄像头，因为只能访问一个视频设备。',
                    canvas: '不支持画布。',
                  }}
                />
              ) : (
                <Webcam
                  ref={camera}
                  audio={false}
                  height={720}
                  screenshotFormat="image/jpeg"
                  width={1280}
                  videoConstraints={{
                    width: 1280,
                    height: 720,
                    facingMode: 'user',
                  }}
                />
              )}
            </>
          ) : (
            <img src={image} alt="" />
          )}
          <div className="absolute top-5 left-5 w-10 h-10 border-t-4 border-l-4 border-white" />
          <div className="absolute top-5 right-5 w-10 h-10 border-t-4 border-r-4 border-white" />
          <div className="absolute bottom-5 left-5 w-10 h-10 border-b-4 border-l-4 border-white" />
          <div className="absolute bottom-5 right-5 w-10 h-10 border-b-4 border-r-4 border-white" />
        </div>
        {!image ? (
          <>
            <div className="p-4 pb-0 flex items-center text-lg mb-2">
              <img src={LightBulb} alt="" />
              <p className="text-gray underline mt-2">自拍小貼士</p>
            </div>
            <p className="p-4 pt-0 text-gray ml-4">
              ・確保四周光線充足
              <br />
              ・與鏡頭保持適當距離
              <br />
              ・確保背景清晰
              <br />
              ・除去太陽眼鏡
              <br />
              ・除去帽子及所有頭飾
            </p>
            <div className="flex justify-center">
              <div
                onClick={() => {
                  if (detectMob()) {
                    setImage(camera.current.takePhoto());
                  } else {
                    setImage(camera.current.getScreenshot());
                  }
                }}
                className="w-12 h-12 rounded-full bg-mercury absolute bottom-10 z-10"
              />
            </div>
          </>
        ) : (
          <>
            <div className="flex justify-center mt-9 mb-4">
              <button style={{width: 160}} disabled={isSubmitting} type="submit" className={`rounded-full text-white text-xl px-14 py-3 ${isSubmitting ? 'bg-mercury' : 'bg-lightningYellow'}`}>
                確定
              </button>
            </div>
            <div className="flex justify-center">
              <button
                className="rounded-full text-white text-xl bg-alto px-10 py-3"
                onClick={() => {
                  //setIsVisible(false);
                  setImage(null);
                }}
              >
                重新拍攝
              </button>
            </div>
          </>
        )}
      </div>
    </form>
  );
}

export default ConfirmSelfieTakePhoto;
